import BuildIcon from "@mui/icons-material/Build";

import CollapsibleListItem from "src/components/List/CollapsibleList";
import { useCourseRelationsContext } from "src/context/CourseRelationsContext";

import AircraftTreeItem from "./AircraftTreeItem";
import CoursesList from "./CoursesList";
import { highlightText } from "./utils";
import type { OperationTreeItemProps } from "./types";

const OperationTreeItem = ({ nodeId, operation, expandedNodeIds, searchTerm }: OperationTreeItemProps) => {
  const key = `${nodeId}/o${operation.id}`;
  const actions = useCourseRelationsContext();
  const { courses, customCourses, groups, aircraft } = operation;
  const hasItems = Boolean(courses?.length || customCourses?.length || groups?.length || aircraft?.length);
  const isExpanded = expandedNodeIds?.has(key) ?? false;

  return (
    <CollapsibleListItem
      icon={<BuildIcon />}
      title={highlightText(operation.name, searchTerm)}
      isExpandable={hasItems}
      nodeId={key}
      onClick={() => actions.nodeClicked(key)}
      forceExpanded={isExpanded}
    >
      <CoursesList
        nodeId={key}
        courses={courses}
        customCourses={customCourses}
        groups={groups}
        searchTerm={searchTerm}
      />

      {aircraft?.map((aircraft) => (
        <AircraftTreeItem
          key={`${key}/a${aircraft.id}`}
          aircraft={aircraft}
          nodeId={key}
          expandedNodeIds={expandedNodeIds}
          searchTerm={searchTerm}
        />
      ))}
    </CollapsibleListItem>
  );
};

export default OperationTreeItem;
